import { Table, Form, Collapse } from "react-bootstrap";

const getAllocation = (allocationMap, sourceID, programmeID) => {
  const alloc = allocationMap.get(`${sourceID}-${programmeID}`);
  return alloc ? alloc.amountFTE : 0;
};

const getSourceRowTotal = (allocationMap, columnProgrammes, sourceID) =>
  columnProgrammes.reduce((sum, prog) => sum + getAllocation(allocationMap, sourceID, prog.ID), 0);

const getProgrammeColumnTotal = (allocationMap, budgetSources, programmeID) =>
  budgetSources.reduce((sum, src) => sum + getAllocation(allocationMap, src.ID, programmeID), 0);

const getGrandTotal = (allocationMap, budgetSources, columnProgrammes) =>
  columnProgrammes.reduce((sum, prog) => sum + getProgrammeColumnTotal(allocationMap, budgetSources, prog.ID), 0);

function BudgetSourcesTable({ budgetSources, columnProgrammes, allocationValues, allocationMap, snapshot, saving, onAllocationChange, onAllocationBlur, onSave, open, onToggle }) {
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h3 className="mb-0">
          <button
            type="button"
            className="collapse-toggle"
            onClick={onToggle}
            aria-expanded={open}
            aria-controls="budgetsources-collapse"
          >
            <i className="far fa-chevron-right collapse-chevron" aria-hidden="true" />
            Budgetbronnen
          </button>
        </h3>
        {!snapshot && open && (
          <button className="btn btn-primary btn-sm" onClick={onSave} disabled={saving}>
            {saving ? 'Opslaan...' : 'Opslaan'}
          </button>
        )}
      </div>
      <Collapse in={open}>
        <div id="budgetsources-collapse">
      <Table bordered hover size="sm" className="contingent-table">
        <thead>
          <tr>
            <th>Bron</th>
            {columnProgrammes.map((prog) => (
              <th key={prog.ID} className="text-center">{prog.name}</th>
            ))}
            <th className="text-end calculated-col">TOTAAL</th>
          </tr>
        </thead>
        <tbody>
          {budgetSources.map((source) => (
            <tr key={source.ID}>
              <td>{source.name}</td>
              {columnProgrammes.map((prog) => (
                <td key={prog.ID} className="text-center">
                  <Form.Control
                    type="text"
                    inputMode="decimal"
                    className="contingent-input"
                    value={allocationValues[`${source.ID}-${prog.ID}`] ?? ""}
                    onChange={(e) => onAllocationChange(source.ID, prog.ID, e.target.value)}
                    onBlur={(e) => onAllocationBlur(source.ID, prog.ID, e.target.value)}
                    disabled={!!snapshot}
                  />
                </td>
              ))}
              <td className="text-end calculated-col fw-bold">
                {getSourceRowTotal(allocationMap, columnProgrammes, source.ID).toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="total-row">
            <td className="fw-bold">TOTAAL personeel</td>
            {columnProgrammes.map((prog) => (
              <td key={prog.ID} className="text-center fw-bold">
                {getProgrammeColumnTotal(allocationMap, budgetSources, prog.ID).toFixed(2)}
              </td>
            ))}
            <td className="text-end fw-bold">
              {getGrandTotal(allocationMap, budgetSources, columnProgrammes).toFixed(2)}
            </td>
          </tr>
        </tfoot>
      </Table>
        </div>
      </Collapse>
    </>
  );
}

export default BudgetSourcesTable;
